import { useEffect, useState } from "react"

import { AudioVideoFacade } from "amazon-chime-sdk-js"

// Important note: to ensure Safari/WebKit compatibility, we are getting our audio stream directly
// from Chime (vs the simpler route of calling `captureStream` on our <audio /> element).

const useChimeMeetingAudioStream = (
  audioVideo: AudioVideoFacade | undefined
): MediaStream | null => {
  const [meetingAudioStream, setMeetingAudioStream] =
    useState<MediaStream | null>(null)

  useEffect(() => {
    if (!audioVideo) {
      setMeetingAudioStream(null)
      return
    }

    audioVideo.getCurrentMeetingAudioStream().then(stream => {
      if (stream?.getAudioTracks().some(track => track.enabled)) {
        setMeetingAudioStream(stream)
      }
    })

    const audioMixObserver = {
      meetingAudioStreamBecameActive: (stream: MediaStream) => {
        if (stream?.getAudioTracks().some(track => track.enabled)) {
          setMeetingAudioStream(stream)
        }
      },
      meetingAudioStreamBecameInactive: () => setMeetingAudioStream(null),
    }
    audioVideo.addAudioMixObserver(audioMixObserver)

    return () => {
      audioVideo.removeAudioMixObserver(audioMixObserver)
      setMeetingAudioStream(null)
    }
  }, [audioVideo])

  return meetingAudioStream
}

export default useChimeMeetingAudioStream
